import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import { FaExclamationTriangle } from 'react-icons/fa'
import { useState } from 'react'
import { useCreateComplaint } from '@/hooks/useReviews'
import Button from '@/components/common/Button/Button'
import Input from '@/components/forms/Input/Input'
import routes from '@/routes/routes'
import './ComplaintCreate.css'

const ComplaintCreate = () => {
    const location = useLocation() as any
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const [subject, setSubject] = useState('')
    const [description, setDescription] = useState('')
    const createComplaint = useCreateComplaint()
    
    const requestId = Number(searchParams.get('serviceRequestId') || location?.state?.requestId || 0)
    const serviceName = searchParams.get('serviceName') || location?.state?.serviceName || 'Servicio'
    const providerName = searchParams.get('providerName') || location?.state?.providerName || 'Proveedor'

    const handleCreate = async () => {
        if (!requestId || !subject.trim() || description.trim().length < 20) return
        await createComplaint.mutateAsync({
            service_request: requestId,
            subject: subject.trim(),
            description: description.trim(),
        })
        navigate(routes.requests)
    }

    return (
        <div className="complaint-create-page">
            <div className="complaint-create-container">
                <h2 className="complaint-create-title">Presentar Queja</h2>
                <div className="complaint-create-form">
                <div className="complaint-create_info">
                    <div className="complaint-create_service">{serviceName}</div>
                    <div className="complaint-create_provider">Proveedor: {providerName}</div>
                </div>

                <div className="complaint-create-warning">
                    <FaExclamationTriangle /> Las quejas son revisadas por nuestro equipo. Sé específico y detallado sobre el problema.
                </div>

                <div className="complaint-create-section">
                    <Input
                        name="subject"
                        label="Asunto *"
                        placeholder="Ej: Servicio no completado"
                        value={subject}
                        setValue={setSubject}
                        maxLength={100}
                        effect3d={false}
                    />
                    <div className="complaint-create-char-count">{subject.length}/100</div>
                </div>

                <div className="complaint-create-section">
                    <Input
                        name="description"
                        label="Descripción del problema *"
                        placeholder="Describe el problema en detalle..."
                        value={description}
                        setValue={setDescription}
                        multiline
                        rows={6}
                        maxLength={1000}
                        effect3d={false}
                    />
                    <div className="complaint-create-char-count">{description.length}/1000 (mínimo 20 caracteres)</div>
                </div>

                <div className="complaint-create_actions">
                    <Button variant="secondary" onClick={() => navigate(routes.requests)} effect3d={false}>Cancelar</Button>
                    <Button
                        variant="danger"
                        onClick={handleCreate}
                        disabled={!subject.trim() || description.trim().length < 20 || createComplaint.isPending}
                        effect3d={false}
                    >
                        {createComplaint.isPending ? 'Enviando...' : 'Enviar Queja'}
                    </Button>
                </div>
                </div>
            </div>
        </div>
    )
}

export default ComplaintCreate


